import { isNotNullOrUndefined } from "common/data-util";
import { ConditionalComponentWrapper } from "components/common/ConditionalComponentWrapper";
import { CHARGING_BILLING_CYCLE_MAP, ChargingAgreement } from "models/charging/agreement";
import React from "react";

interface NewChargingAgreementServiceCardProps {
  agreement: ChargingAgreement;
  agreementEndDate?: string;
}

export function NewChargingAgreementServiceCard({
  agreement
} : NewChargingAgreementServiceCardProps ){

  const serviceOption = agreement.serviceOption;
  const pricing = agreement.pricing;
  const infoClassName = 'col-5 col-sm-6 col-xl-9 p-0 text-gray-700 u-fs-14 mr-2';

  return (
      <div className="d-lg-flex justify-content-between align-items-center u-fs-16">
        <div className="d-flex flex-column flex-1">
            <div className="d-flex mb-3 align-items-center">
                <i className="icon__charging mr-3"></i>
                <div>
                  <h2 className="mb-1">{serviceOption.name}</h2>
                  <p className="mb-1">{serviceOption.description}</p>
                </div>
            </div>

            <div className="row">
              <div className="col-xl-6 col-xxl-4">
                <ConditionalComponentWrapper condition={isNotNullOrUndefined(pricing.thirdPartyChargingMarginalCentsKwh)} className="row">
                  <div className="col d-flex align-items-center">
                      <div className={infoClassName}>Teenuse marginaal kolmandate isikute laadimiste eest:</div>
                      <div className="font-weight-bold">{pricing.thirdPartyChargingMarginalCentsKwh} s/kWh</div>
                  </div>               
                </ConditionalComponentWrapper>
                <ConditionalComponentWrapper condition={isNotNullOrUndefined(pricing.chargingServiceMonthlyFeeEuros)} className="row">
                  <div className="col d-flex align-items-center">
                      <div className={infoClassName}>Teenuse kuutasu:</div>
                      <div className="font-weight-bold">{pricing.chargingServiceMonthlyFeeEuros} €</div>
                  </div>            
                </ConditionalComponentWrapper>
                <ConditionalComponentWrapper condition={isNotNullOrUndefined(pricing.mediationAndBillingMonthlyFeePerNozzleEuros)} className="row">
                  <div className="col d-flex align-items-center">
                    <div className={infoClassName}>Arveldusteenuse ja arveldamise vahendamisteenuse kuutasu otsiku kohta:</div>
                    <div className="font-weight-bold">{pricing.mediationAndBillingMonthlyFeePerNozzleEuros} €</div>
                  </div>            
                </ConditionalComponentWrapper>
                <ConditionalComponentWrapper condition={isNotNullOrUndefined(pricing.infrastructureUsageOneTimeFeePerNozzleEuros)} className="row">
                  <div className="col d-flex align-items-center">
                    <div className={infoClassName}>Infrastruktuuri kasutamise ühekordne tasu otsiku kohta:</div>
                    <div className="font-weight-bold">{pricing.infrastructureUsageOneTimeFeePerNozzleEuros} €</div>
                  </div>            
                </ConditionalComponentWrapper>
                <ConditionalComponentWrapper condition={isNotNullOrUndefined(pricing.infrastructureUsageMonthlyFeePerNozzleEuros)} className="row">
                  <div className="col d-flex align-items-center">
                    <div className={infoClassName}>Infrastruktuuri kasutamise kuutasu laadija otsiku kohta:</div>
                    <div className="font-weight-bold">{pricing.infrastructureUsageMonthlyFeePerNozzleEuros} €</div>
                  </div>            
                </ConditionalComponentWrapper>
                <ConditionalComponentWrapper condition={isNotNullOrUndefined(pricing.gridDayTariffCentsKwh)} className="row">
                  <div className="col d-flex align-items-center">
                    <div className={infoClassName}>Päevatariif:</div>
                    <div className="font-weight-bold">{pricing.gridDayTariffCentsKwh} s/kWh</div>
                  </div>            
                </ConditionalComponentWrapper>
                <ConditionalComponentWrapper condition={isNotNullOrUndefined(pricing.gridNightTariffCentsKwh)} className="row">
                  <div className="col d-flex align-items-center">
                    <div className={infoClassName}>Öötariif:</div>
                    <div className="font-weight-bold">{pricing.gridNightTariffCentsKwh} s/kWh</div>
                  </div>            
                </ConditionalComponentWrapper>
                <ConditionalComponentWrapper condition={isNotNullOrUndefined(agreement.advancePaymentEuros)} className="row">
                  <div className="col d-flex align-items-center">
                    <div className={infoClassName}>Ettemaks enne seadmete paigaldust:</div>
                    <div className="font-weight-bold">{agreement.advancePaymentEuros} €</div>
                  </div>            
                </ConditionalComponentWrapper>

              </div>
              <div className="col-xl-6 col-xxl-4">
                <ConditionalComponentWrapper condition={isNotNullOrUndefined(agreement.simCardCount)} className="row">
                  <div className="col d-flex align-items-center">
                    <div className={infoClassName}>SIM-kaartide arv:</div>
                    <div className="font-weight-bold">{agreement.simCardCount} tk</div>
                  </div>            
                </ConditionalComponentWrapper>
                <ConditionalComponentWrapper condition={isNotNullOrUndefined(agreement.simCardPaymentType)} className="row">
                  <div className="col d-flex align-items-center">
                      <div className={infoClassName}>SIM-kaardi makse sagedus:</div>
                      <div className="col-5 p-0 font-weight-bold">{CHARGING_BILLING_CYCLE_MAP[agreement.simCardPaymentType!]}</div>
                  </div>      
                </ConditionalComponentWrapper>
                <ConditionalComponentWrapper condition={isNotNullOrUndefined(pricing.simCardMonthlyFeeEuros)} className="row">
                  <div className="col d-flex align-items-center">
                      <div className={infoClassName}>SIM-kaardi kuutasu kaardi kohta:</div>
                      <div className="font-weight-bold">{pricing.simCardMonthlyFeeEuros} €</div>
                  </div>    
                </ConditionalComponentWrapper>
                <ConditionalComponentWrapper condition={isNotNullOrUndefined(agreement.rfidPaymentCardCount)} className="row">
                  <div className="col d-flex align-items-center">
                      <div className={infoClassName}>RFID-kaartide arv:</div>
                      <div className="font-weight-bold">{agreement.rfidPaymentCardCount} tk</div>
                  </div>    
                </ConditionalComponentWrapper>
                <ConditionalComponentWrapper condition={isNotNullOrUndefined(pricing.rfidPaymentCardMonthlyFeeEuros)} className="row">
                  <div className="col d-flex align-items-center">
                    <div className={infoClassName}>RFID-kaardi hind:</div>
                    <div className="font-weight-bold">{pricing.rfidPaymentCardMonthlyFeeEuros} €</div>
                  </div>    
                </ConditionalComponentWrapper>
            </div>
            </div>
            <div className="row mt-2">
                <div className="col text-gray-700 u-fs-14">
                  Hindadele lisandub käibemaks
                </div>
            </div>
            <div className="col p-0 d-flex mt-2">
              <div className="d-flex align-items-center">
                <div className="col p-0 text-gray-700 u-fs-14 mr-2">Lepingu periood:</div>
                <div className="font-weight-bold">{agreement.contractPeriod.name}</div>
              </div>
            </div>
        </div>
    </div>
  );
}